import { render, staticRenderFns } from "./DetailChatAdmin.vue?vue&type=template&id=709e5b36&scoped=true"
import script from "./DetailChatAdmin.vue?vue&type=script&lang=js"
export * from "./DetailChatAdmin.vue?vue&type=script&lang=js"
import style0 from "./DetailChatAdmin.vue?vue&type=style&index=0&id=709e5b36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709e5b36",
  null
  
)

export default component.exports